/**
 * Route for `real-time-reporting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeReportingPage } from "../features/real-time-reporting/RealTimeReportingPage";

export const realTimeReportingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-reporting",
	component: RealTimeReportingPage,
});

export default realTimeReportingRoute;
